var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLightContract = function SvgIconLightContract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-light-contract-mask0_73_12982",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 0H0v40h40z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-light-contract-mask0_73_12982)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "M20.438 17.25H17.75c-.375 0-.625-.25-.625-.625s.25-.625.625-.625h2.688c.375 0 .687-.312.687-.75 0-.437-.312-.75-.687-.75h-1.313c-1.062 0-1.937-.875-1.937-2s.875-2 1.937-2h2.688c.375 0 .625.25.625.625s-.25.625-.625.625h-2.688c-.375 0-.687.313-.687.75 0 .438.312.75.687.75h1.313c1.062 0 1.937.875 1.937 2 0 1.063-.875 2-1.937 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "M19.75 11.813c-.375 0-.625-.25-.625-.626V9.814c0-.376.25-.626.625-.626s.625.25.625.626v1.374c0 .313-.25.626-.625.626M19.75 18.563c-.375 0-.625-.25-.625-.625v-1.375c0-.375.25-.625.625-.625s.625.25.625.624v1.375c0 .375-.25.625-.625.625"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00293C",
    d: "M29.75 14.5h-5.312c-.375 0-.625-.25-.625-.625s.25-.625.625-.625h5.312c.375 0 .625.25.625.625s-.25.625-.625.625M29.75 18.563h-5.312c-.375 0-.625-.25-.625-.625s.25-.625.625-.625h5.312c.375 0 .625.25.625.625s-.25.625-.625.625M29.75 10.438h-5.312c-.375 0-.625-.25-.625-.626 0-.374.25-.624.625-.624h5.312c.375 0 .625.25.625.624 0 .376-.25.626-.625.626M29.75 22.688h-12c-.375 0-.625-.25-.625-.625s.25-.625.625-.625h12c.375 0 .625.25.625.625s-.25.625-.625.625M29.75 26.75h-5.312c-.375 0-.625-.25-.625-.625s.25-.625.625-.625h5.312c.375 0 .625.25.625.625s-.25.625-.625.625"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00293C",
    d: "M16.438 36.25c-1.813 0-3.313-1.5-3.313-3.312V7.061c0-1.125-.875-2.062-2-2.062-.375 0-.625-.25-.625-.625s.25-.625.625-.625h20c1.75 0 3.25 1.5 3.25 3.313v21.75c0 .375-.25.625-.625.625s-.625-.25-.625-.625V7.063A2.08 2.08 0 0 0 31.063 5H13.688a3.4 3.4 0 0 1 .687 2.063v25.812a2.08 2.08 0 0 0 2.063 2.063c.375 0 .625.25.625.624 0 .376-.25.688-.625.688"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00293C",
    d: "M11.125 26.75H5.813c-.375 0-.625-.25-.625-.625s.25-.625.625-.625a2.08 2.08 0 0 0 2.062-2.062V7.063C7.813 5.25 9.313 3.75 11.125 3.75c.375 0 .625.25.625.625S11.5 5 11.125 5a2.08 2.08 0 0 0-2.062 2.063v16.312q0 1.219-.75 2.063h2.75c.374 0 .624.25.624.625s-.25.687-.562.687"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00293C",
    d: "M5.813 26.75C4 26.75 2.5 25.25 2.5 23.438V12.5c0-.375.25-.625.625-.625h2.688c.375 0 .625.25.625.625s-.25.625-.625.625H3.75v10.25a2.08 2.08 0 0 0 2.063 2.063c.375 0 .625.25.625.625s-.313.687-.625.687M33.75 36.25H16.438c-.375 0-.625-.25-.625-.625s.25-.625.624-.625a2.08 2.08 0 0 0 2.063-2.062v-1.376c0-.375.25-.625.625-.625h17.313c.374 0 .624.25.624.625v1.375c0 1.813-1.5 3.313-3.312 3.313M19 35h14.75a2.08 2.08 0 0 0 2.063-2.062v-.75H19.75v.75c0 .75-.312 1.5-.75 2.062"
  }))));
};
export default SvgIconLightContract;